// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auto-feed-header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
    margin-top: 20px;
    min-height: 40px;
}

.auto-page-number {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    width: 100px;
    background-color: #f8f8fa;
    cursor: pointer;
}

.auto-header-span {
    margin: 0 10px;
    font-size: 20px;
    font-family: 'Gilroy-Bold';
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
}

.active {
    color: #767676;
}

.auto-profile-state-header {
    display: flex;
    align-items: center;
    border-radius: 30px;
    justify-content: center;
    width: 400px;
    background-color: #f8f8fa;
    cursor: pointer;
}

.auto-date-filter {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 14px;
    height: 40px;
    border-radius: 30px;
    background-color: #f8f8fa;
}

.auto-date-label {
    font-size: 16px;
    font-family: 'Gilroy-Bold';
    color: #767676;
}

.auto-date-input {
    border: none;
    background: transparent;
    font-size: 16px;
    font-family: 'Gilroy-Bold';
    color: #484848;
    outline: none;
}

.auto-image-container {
    
}

.auto-image-container-hive-curated {

}

.auto-crop-icon-div {
    width: 15px;
    height: 15px;
    margin-top: -30px;
    margin-left: 125px;
    background-color: #ffffff;
    border: solid 3px #ffffff;
    display: flex;
    border-radius: 35px;
    position: absolute;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    visibility: hidden;
}

.auto-delete-icon-div {
    width: 15px;
    height: 15px;
    margin-top: -30px;
    margin-left: 10px;
    background-color: #ffffff;
    border: solid 3px #ffffff;
    display: flex;
    border-radius: 35px;
    position: absolute;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    visibility: hidden;
}

.auto-image-container:hover .auto-crop-icon-div{
    visibility: visible;
}

.auto-image-container:hover .auto-delete-icon-div{
    visibility: visible;
}

.auto-image-container-hive-curated:hover .auto-crop-icon-div{
    visibility: visible;

}

.auto-image-container-hive-curated:hover .auto-delete-icon-div{
    visibility: visible;
}

.auto-profile-container-main{
    margin: 50px 0 0 50px;
}


.auto-profile-container {
    display: flex;
}

.hive-curated-border {
    border: solid 4px #d7d7d7;
    border-radius: 15px;
}

.auto-profile-image {
    margin-right: 10px;
    border-radius: 15px;
}

.auto-heart-div {
  width: 15px;
  height: 15px;
  margin-left: 8.5%;
  margin-top: -10%;
  background-color: #ffffff;
  border: solid 3px #9b9b9b;
  position: absolute;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  visibility: hidden;
}

.auto-heart-div-ipad {
    width: 15px;
    height: 15px;
    margin-left: 10.5%;
    margin-top: -12.5%;
    background-color: #ffffff;
    border: solid 3px #9b9b9b;
    position: absolute;
    border-radius: 35px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    visibility: hidden;
  }

.auto-heart-div-selected {
    border: 3px solid #53e03f;
  }

.auto-image-container:hover .auto-heart-div{
    visibility: visible;
}

.auto-image-container:hover .auto-heart-div-ipad{
    visibility: visible;
}

.auto-image-container-hive-curated:hover .auto-heart-div{
    visibility: visible;

}

.auto-image-container-hive-curated:hover .auto-heart-div-ipad{
    visibility: visible;
}

.auto-chrome-icon-div {
    width: 15px;
    height: 15px;
    margin-left: 1%;
    margin-top: -10%;
    background-color: #ffffff;
    position: absolute;
    border-radius: 35px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    visibility: hidden;
}

.auto-chrome-icon-div-ipad {
    width: 15px;
    height: 15px;
    margin-left: 1%;
    margin-top: -12.5%;
    background-color: #ffffff;
    position: absolute;
    border-radius: 35px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    visibility: hidden;
}

.auto-image-container:hover .auto-chrome-icon-div{
    visibility: visible;
}

.auto-image-container:hover .auto-chrome-icon-div-ipad{
    visibility: visible;
}

.auto-image-container-hive-curated:hover .auto-chrome-icon-div{
    visibility: visible;
}

.auto-image-container-hive-curated:hover .auto-chrome-icon-div-ipad{
    visibility: visible;
}

.auto-action-button {
  cursor: pointer;
  width: 50px;
  height: 66px;
  border-radius: 33px;
  box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
  border: solid 1px #d7d7d7;
  background-color: #ffffff;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #002b37;
  font-family: 'Gilory-Bold';
}

.auto-approve-active {
    background-color: green;
    color: white;
}

.auto-disapprove-active {
    background-color: red;
    color: white;
}

.auto-inapp-active {
    background-color: black;
    color: white;
}

.auto-profile-div {
    margin-bottom: 50px;
    align-items: center;
}

.auto-profile-details {
    max-width: calc(100vw - 260px);
    margin: 0 0 16px;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.5;
}

.auto-display-flex {
    display: flex;
}

.auto-visibiliy-hidden {
    visibility: hidden;
}

.auto-action-button-div {
    margin-left: 2%;
    text-align: center;
}

.auto-page-control {
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.auto-jusitfy-center {
    justify-content: center;
}

.tooltip {
    position: relative;
    cursor: pointer;
    color: red;
    text-align: center;
    width: 150px;
    height: 20px;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: auto;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    padding: 5px;
    
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -70px;
    
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

.color-green {
color: green;
}

.color-red {
    color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/FeedAutoCurated.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,aAAa;AACjB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;AAEF;IACI,yBAAyB;EAC3B;;AAEF;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;;IAEZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;;IAElB,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;AAEF;AACA,YAAY;AACZ;;AAEA;IACI,UAAU;AACd","sourcesContent":[".auto-feed-header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 18px;\n    flex-wrap: wrap;\n    margin-top: 20px;\n    min-height: 40px;\n}\n\n.auto-page-number {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 30px;\n    width: 100px;\n    background-color: #f8f8fa;\n    cursor: pointer;\n}\n\n.auto-header-span {\n    margin: 0 10px;\n    font-size: 20px;\n    font-family: 'Gilroy-Bold';\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #d7d7d7;\n}\n\n.active {\n    color: #767676;\n}\n\n.auto-profile-state-header {\n    display: flex;\n    align-items: center;\n    border-radius: 30px;\n    justify-content: center;\n    width: 400px;\n    background-color: #f8f8fa;\n    cursor: pointer;\n}\n\n.auto-date-filter {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 0 14px;\n    height: 40px;\n    border-radius: 30px;\n    background-color: #f8f8fa;\n}\n\n.auto-date-label {\n    font-size: 16px;\n    font-family: 'Gilroy-Bold';\n    color: #767676;\n}\n\n.auto-date-input {\n    border: none;\n    background: transparent;\n    font-size: 16px;\n    font-family: 'Gilroy-Bold';\n    color: #484848;\n    outline: none;\n}\n\n.auto-image-container {\n    \n}\n\n.auto-image-container-hive-curated {\n\n}\n\n.auto-crop-icon-div {\n    width: 15px;\n    height: 15px;\n    margin-top: -30px;\n    margin-left: 125px;\n    background-color: #ffffff;\n    border: solid 3px #ffffff;\n    display: flex;\n    border-radius: 35px;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    visibility: hidden;\n}\n\n.auto-delete-icon-div {\n    width: 15px;\n    height: 15px;\n    margin-top: -30px;\n    margin-left: 10px;\n    background-color: #ffffff;\n    border: solid 3px #ffffff;\n    display: flex;\n    border-radius: 35px;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    visibility: hidden;\n}\n\n.auto-image-container:hover .auto-crop-icon-div{\n    visibility: visible;\n}\n\n.auto-image-container:hover .auto-delete-icon-div{\n    visibility: visible;\n}\n\n.auto-image-container-hive-curated:hover .auto-crop-icon-div{\n    visibility: visible;\n\n}\n\n.auto-image-container-hive-curated:hover .auto-delete-icon-div{\n    visibility: visible;\n}\n\n.auto-profile-container-main{\n    margin: 50px 0 0 50px;\n}\n\n\n.auto-profile-container {\n    display: flex;\n}\n\n.hive-curated-border {\n    border: solid 4px #d7d7d7;\n    border-radius: 15px;\n}\n\n.auto-profile-image {\n    margin-right: 10px;\n    border-radius: 15px;\n}\n\n.auto-heart-div {\n  width: 15px;\n  height: 15px;\n  margin-left: 8.5%;\n  margin-top: -10%;\n  background-color: #ffffff;\n  border: solid 3px #9b9b9b;\n  position: absolute;\n  border-radius: 35px;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  align-items: center;\n  visibility: hidden;\n}\n\n.auto-heart-div-ipad {\n    width: 15px;\n    height: 15px;\n    margin-left: 10.5%;\n    margin-top: -12.5%;\n    background-color: #ffffff;\n    border: solid 3px #9b9b9b;\n    position: absolute;\n    border-radius: 35px;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n    align-items: center;\n    visibility: hidden;\n  }\n\n.auto-heart-div-selected {\n    border: 3px solid #53e03f;\n  }\n\n.auto-image-container:hover .auto-heart-div{\n    visibility: visible;\n}\n\n.auto-image-container:hover .auto-heart-div-ipad{\n    visibility: visible;\n}\n\n.auto-image-container-hive-curated:hover .auto-heart-div{\n    visibility: visible;\n\n}\n\n.auto-image-container-hive-curated:hover .auto-heart-div-ipad{\n    visibility: visible;\n}\n\n.auto-chrome-icon-div {\n    width: 15px;\n    height: 15px;\n    margin-left: 1%;\n    margin-top: -10%;\n    background-color: #ffffff;\n    position: absolute;\n    border-radius: 35px;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n    align-items: center;\n    visibility: hidden;\n}\n\n.auto-chrome-icon-div-ipad {\n    width: 15px;\n    height: 15px;\n    margin-left: 1%;\n    margin-top: -12.5%;\n    background-color: #ffffff;\n    position: absolute;\n    border-radius: 35px;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n    align-items: center;\n    visibility: hidden;\n}\n\n.auto-image-container:hover .auto-chrome-icon-div{\n    visibility: visible;\n}\n\n.auto-image-container:hover .auto-chrome-icon-div-ipad{\n    visibility: visible;\n}\n\n.auto-image-container-hive-curated:hover .auto-chrome-icon-div{\n    visibility: visible;\n}\n\n.auto-image-container-hive-curated:hover .auto-chrome-icon-div-ipad{\n    visibility: visible;\n}\n\n.auto-action-button {\n  cursor: pointer;\n  width: 50px;\n  height: 66px;\n  border-radius: 33px;\n  box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);\n  border: solid 1px #d7d7d7;\n  background-color: #ffffff;\n  font-size: 20px;\n  font-weight: 800;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #002b37;\n  font-family: 'Gilory-Bold';\n}\n\n.auto-approve-active {\n    background-color: green;\n    color: white;\n}\n\n.auto-disapprove-active {\n    background-color: red;\n    color: white;\n}\n\n.auto-inapp-active {\n    background-color: black;\n    color: white;\n}\n\n.auto-profile-div {\n    margin-bottom: 50px;\n    align-items: center;\n}\n\n.auto-profile-details {\n    max-width: calc(100vw - 260px);\n    margin: 0 0 16px;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.5;\n}\n\n.auto-display-flex {\n    display: flex;\n}\n\n.auto-visibiliy-hidden {\n    visibility: hidden;\n}\n\n.auto-action-button-div {\n    margin-left: 2%;\n    text-align: center;\n}\n\n.auto-page-control {\n    margin-bottom: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n}\n\n.auto-jusitfy-center {\n    justify-content: center;\n}\n\n.tooltip {\n    position: relative;\n    cursor: pointer;\n    color: red;\n    text-align: center;\n    width: 150px;\n    height: 20px;\n  }\n\n  .tooltip .tooltiptext {\n    visibility: hidden;\n    width: auto;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 5px;\n    padding: 5px;\n    \n    position: absolute;\n    z-index: 1;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -70px;\n    \n    opacity: 0;\n    transition: opacity 0.3s;\n  }\n\n  .tooltip:hover .tooltiptext {\n    visibility: visible;\n    opacity: 1;\n  }\n\n.color-green {\ncolor: green;\n}\n\n.color-red {\n    color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
